import { Account } from "@bn/api/apiv1";

/**
 * DOM id of an account's row in the depots and accounts list. Shared so that
 * whoever links at a row and the list itself cannot drift apart.
 */
export const accountRowId = (accountId: number) => `account-${accountId}`;

export const getRedirectType = (val: Account): "depots" | "accounts" => {
  if (
    val.typeFromBank === "CREDIT_CARD" ||
    val.type === "02_cash" ||
    val.type === "04_insurance"
  ) {
    return "accounts";
  }
  if (val.type === "01_depot" || val.type === "05_material_assets") {
    return "depots";
  }

  return "depots";
};
